if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
      this.ticking = false;
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick, { passive: true });
      window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    }

    onScroll() {
      if (!this.ticking) {
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.checkVisible();
          this.ticking = false;
        });
      }
    }

    checkVisible() {
      if (window.scrollY > this.pageHeight) {
        this.classList.add('back-to-top--active');
      } else {
        this.classList.remove('back-to-top--active');
      }
    }

    onClick() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }
  customElements.define('back-to-top', BackToTop);
}